import React from 'react';
import Select from 'react-select';
import {Constants} from '../helpers';
import {customStyles, DropdownIndicator} from './ReactSelect';

export default function CountryInput({
  defaultValue,
  value,
  onChange,
  label,
  lookupType,
  options: customOptions,
  ...rest
}) {
  const filterOutAngolaForBatch =
    lookupType === 'Batch'
      ? Constants.lookups.countries.filter(e => e.value !== 'angola')
      : Constants.lookups.countries;

  const options = customOptions || filterOutAngolaForBatch;

  return (
    <>
      <label htmlFor="country" className="mb-1 relative">
        {label}
      </label>
      <Select
        defaultValue={defaultValue || options[0]}
        value={value}
        onChange={onChange}
        options={options}
        placeholder="Select country"
        components={{DropdownIndicator}}
        classNamePrefix="react-select"
        styles={customStyles}
        getOptionLabel={e => (
          <div style={{display: 'flex', alignItems: 'center'}}>
            {e.icon}
            <span style={{marginLeft: 8, marginBottom: -4}}>{e.label}</span>
          </div>
        )}
        isSearchable={false}
        {...rest}
      />
    </>
  );
}
